import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import ScrollToTop from "./components/ScrollToTop";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import HairServices from "./pages/HairServices";
import HairExtensions from "./pages/HairExtensions";
import BlondeSpecialist from "./pages/BlondeSpecialist";
import BeautyServices from "./pages/BeautyServices";
import Facials from "./pages/Facials";
import HIFU from "./pages/HIFU";
import BeautyPriceList from "./pages/BeautyPriceList";
import SuperHairRemoval from "./pages/SuperHairRemoval";
import LaserHairRemoval from "./pages/LaserHairRemoval";
import WellnessServices from "./pages/WellnessServices";
import WaterfallHeadSpa from "./pages/WaterfallHeadSpa";
import Contact from "./pages/Contact";
import Sustainability from "./pages/Sustainability";
import OurProducts from "./pages/OurProducts";
import AspectSkincare from "./pages/AspectSkincare";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/hair" element={<HairServices />} />
            <Route path="/hair-extensions" element={<HairExtensions />} />
            <Route path="/blonde-specialist" element={<BlondeSpecialist />} />
            <Route path="/beauty" element={<BeautyServices />} />
            <Route path="/facials" element={<Facials />} />
            <Route path="/hifu" element={<HIFU />} />
            <Route path="/beauty-price-list" element={<BeautyPriceList />} />
            <Route path="/super-hair-removal" element={<SuperHairRemoval />} />
            <Route path="/laser-hair-removal" element={<LaserHairRemoval />} />
            <Route path="/wellness" element={<WellnessServices />} />
            <Route path="/waterfall-head-spa" element={<WaterfallHeadSpa />} />

            <Route path="/sustainability" element={<Sustainability />} />
            <Route path="/our-products" element={<OurProducts />} />
            <Route path="/aspect-skincare" element={<AspectSkincare />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
          <Footer />
          <Toaster position="top-right" />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
